import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Geógrafo de la <span className="purple">Universidad Austral de Chile</span>, con un diplomado en <span className="purple">Planificación y Gestión Urbana Integrada</span> de la Pontificia Universidad Católica. Actualmente me desempeño como Geógrafo en el <span className="purple">Centro de Inteligencia Territorial (CIT)</span> de la Universidad Adolfo Ibáñez.
            <br /><br /> 
            Mis intereses se orientan hacia la <span className="purple">geografía urbana</span>, abarcando desde la geografía crítica hasta el análisis espacial.
            <br /><br />
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
